import React, { Component } from "react";
import Crew_Neck_Soccer_HalfDesign1 from "../components/Crew_Neck_Soccer_HalfDesign1/Crew_Neck_Soccer_HalfDesign1";

export class Crew_Neck_Soccer_HalfDesign1Page extends Component {
  render() {
    return <Crew_Neck_Soccer_HalfDesign1 />;
  }
}

export default Crew_Neck_Soccer_HalfDesign1Page;
